export default "__VITE_ASSET__071e7476__"